import { useState, useEffect } from "react";
import { useAuth } from '../../../../../../../../context/AuthContext';
import { useParams } from 'react-router-dom';
import axios from "axios";
import RealMatch from "./UI/RealMatch"
import VideoContent from "./UI/VideoContent"
import Choice from "./UI/Choice"
import Write from "./UI/Write";
import Match from "./UI/Match";
import TrueFalse from "./UI/TrueFalse";
import Sentence from "./UI/Sentence";


export const AdminEditQuestion = () => {
    const [loadingQuestion, setLoadingQuestion] = useState(true);
    const { user } = useAuth();
    const [data, setData] = useState([]);
    const [questionType, setquestionType] = useState([]);

    const [msg, setMsg] = useState([]);
    const params = useParams()
    const getQuestion = async () => {
        setLoadingQuestion(true)
        try {
            const headerss = {
                "accept": "*/*",
                'Content-Type': 'application/json',
                'Access-Control-Allow-Credentials': 'false',
                'Authorization': 'Bearer ' + user.token
            }
            let url = "https://api.heryerdeingilizce.com/api/admin/ContentManager/GetById";
            await axios({
                method: 'GET',
                url: url,
                headers: headerss,
                params: {
                    id: params["id"]
                }
            }).then(res => {
                if (res.status === 200) {
                    if (res.data['success']) {
                        setData(res.data['data'])
                        console.log("soru detay");
                        console.log(res.data['data']);

                    }
                    else {
                        setMsg(res.data['message']);
                    }
                }
                else {
                    setMsg("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
                }
            });
        }
        catch (err) {
            setMsg(err);
        }
        setLoadingQuestion(false);
    }

    useEffect(() => {
        setquestionType(params['type']);
        getQuestion();
    }, [])

    if (!loadingQuestion) {
        if (questionType === 'video') {
            return (
                <div style={{ position: "relative" }}>
                    <VideoContent data={data} />
                </div>
            )
        }
        else if (questionType === 'write') {
            return (
                <div>
                    <Write data={data} />
                </div >
            )
        }
        else if (questionType === 'choice') {
            return (
                <div  >
                    <Choice data={data} />

                </div >
            )
        }
        else if (questionType === 'match') {
            return (
                <div>
                    <Match data={data} />

                </div >
            )
        }
        else if (questionType === 'truefalse') {
            return (
                <div >
                    <TrueFalse data={data} />

                </div >
            )
        }
        else if (questionType === 'realmatch') {
            return (
                <div>
                    <RealMatch data={data} />
                </div >
            )
        }
        else if (questionType === 'sentence') {
            return (
                <div>
                    <Sentence data={data} />

                </div >
            )
        }


    }

};
export default AdminEditQuestion;
